import { useColorScheme } from "react-native";
import { resolveDark, type Palette, type ThemeFamily } from "@heraion/shared";
import { resolveTheme, useThemePreferenceContext } from "@heraion/ui";

// web-rnw theme hooks. They combine RN's useColorScheme (react-native-web maps
// it onto matchMedia AND subscribes to change events, so a live OS-scheme flip
// updates the app with no reload) with the user's persisted ThemePreference
// (palette family + light/dark mode) from ThemeContext. This matches mobile
// (apps/mobile/src/theme/tokens.ts). With NO provider mounted (bare/test render)
// both hooks fall back to today's behaviour: OS scheme + the "brand" family.

function useDark(): boolean {
  const osDark = useColorScheme() === "dark";
  const mode = useThemePreferenceContext()?.preference.mode;
  return mode ? resolveDark(mode, osDark) : osDark;
}

function useThemeFamily(): ThemeFamily {
  return useThemePreferenceContext()?.preference.family ?? "brand";
}

export function useThemePalette(): { dark: boolean; family: ThemeFamily; p: Palette } {
  const dark = useDark();
  const family = useThemeFamily();
  return { dark, family, p: resolveTheme(dark, family).palette };
}
